import html2canvas from "html2canvas-pro";

function isMobile() {
  const minWidth = 768;
  return window.innerWidth < minWidth || screen.width < minWidth;
}

function artifactGenerator() {
  if (!$("#epi-quickNavigator-menu").length) return;
  $("#epi-quickNavigator-menu li:nth(1)")
  .on("click", (event) => {
    var date = new Date().toLocaleString();
    var path = encodeURI(window.location.href);
    var fileName = path.slice(8);

    if (isMobile()) {
      fileName = "Mobile_Artefact_" + date + "_" + fileName;
    } else {
      fileName = "Desktop_Artefact_" + date + "_" + fileName;
    }

    if (fileName.length >= 255) {
      var shortFilename =  fileName.slice(0, 250);
      fileName = shortFilename;
    }

    event.preventDefault();
    $("#epi-quickNavigator").css("display", "none");
    $(".collapse").addClass("show");
    html2canvas(document.body).then((canvas) => {
      let image = canvas
        .toDataURL("image/png")
        .replace("image/png", "image/octect-stream");
      let link = document.createElement("a");
      link.download = fileName + ".png";
      link.href = image;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      $("#epi-quickNavigator").css("display", "block");
      $(".collapse").removeClass("show");
    }).catch(err => {
      console.error(err);
    });
  });

  clearInterval(checkIfButtonIsLoaded);
}

let checkIfButtonIsLoaded = setInterval(artifactGenerator, 1000);

